export default __webpack_public_path__ + "static/media/mag1.6c86b72c.png";